// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","addToCart":"buy-it-now_addToCart__2OLFc","icon":"buy-it-now_icon__PL4XI"};